import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  Row,
  Col,
  Grid,
  Input,
  ControlLabel,
  SelectPicker,
  Button,
  ButtonToolbar,
  Modal,
  FlexboxGrid,
  List,
} from 'rsuite'
import pathname from '../../constants/pathname'
import AppContext from '../../context/AppContext'
import './styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import ConfirmWidget from '../confirm/ConfirmWidget'
import ProjectBasicInfo from '../projectBasicInfo/ProjectBasicInfoUnshaded'
import { budgetFormat } from '../../utils/formatterUtil'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { SUB_PROJECT_ID } from '../../constants/constants'
import { createSubProject, getPropersalTemplate } from '../../redux/actions/subProjectManage'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function TableSubProjectList({
  schema,
  totalBudget,
  subName,
  single,
  onSingleSubmit = () => {},
  muti,
  onMutiSubmit,
  enableView,
  onView,
  onRemove,
  onReload,
  pagination,
  lengthMenu,
  loading,
  hiddenColStatus,
  searchRows,
  onSearchProject,
  onCancelSelectProject,
  Controller,
  control,
  ProjectId,
  ...props
}) {
  const { Column, HeaderCell, Cell, ColumnGroup } = Table
  // const { Paragraph } = Placeholder
  const history = useHistory()
  // const [selectList, setSelectList] = useState([])
  // const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  // const contextValue = React.useContext(AppContext)
  const [tableData, setTableData] = useState([])
  const [inputValueCode, setInputValueCode] = useState('')
  const [inputValueName, setInputValueName] = useState('')
  const [inputValueStatus, setInputValueStatus] = useState('')
  // const [useProjectId, setUseProject] = useState(ProjectId)
  const [isShowConfirmAddSubproject, setIsShowConfirmAddSubproject] = useState(false)
  const [isShowSelectTemple, setIsShowSelectTemple] = useState(false)
  const [thempSchema, setThempSchema] = useState()
  const [subFormId, setSubFormId] = useState()

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema.subProjectList.values) {
      setTableData(schema.subProjectList.values)
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  useEffect(() => {
    if (tableData) {
      tableData.push({
        isRowTotal: true,
        projectStatus: 'จำนวนเงินรวม',
        projectBudget: totalBudget || 0,
      })
    }
  }, [tableData])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1, inputValueCode, inputValueName, inputValueStatus)
    }
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey, inputValueCode, inputValueName, inputValueStatus)
    }
  }

  const getData = () => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleChangeProjectCode = (val) => {
    setInputValueCode(val)
  }

  const handleChangeProjectName = (val) => {
    setInputValueName(val)
  }

  const handleSearchProject = () => {
    onSearchProject(5, 1, inputValueCode, inputValueName, inputValueStatus)
    setPage(1)
  }

  const handleCancelSearchProject = () => {
    setInputValueCode('')
    setInputValueName('')
    onSearchProject(5, 1, '', '', '')
    setPage(1)
  }

  const handleCreateSubProject = async () => {
    try {
      // console.log('subFormId : ', subFormId)
      const response = await createSubProject(schema?.projectInfo?.projectCode, subFormId)
      if (response) {
        sessionStorage.setItem('projectId', response.id)
        sessionStorage.setItem(SUB_PROJECT_ID, response.id)
        sessionStorage.setItem('param', '')

        history.push({
          pathname: `${pathname.subProjectNew.proposal.projectName}`,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (error) {
      console.log(error)
      notification.open('error', {
        title: error?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
  }

  const handleGetTempalteSchema = async (projectCode) => {
    setIsLoading(true)
    startLoading()
    try {
      let _schema = await getPropersalTemplate(projectCode)
      setThempSchema(_schema)
      setIsShowSelectTemple(true)
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const HeaderSummary = ({ title, summary }) => (
    <div>
      <label>{`${title}`}</label>
      <div
        style={{
          fontSize: 16,
          color: '#2da888',
        }}
      >
        {`รวม ${summary}`}
      </div>
    </div>
  )

  const SubnameCell = ({ rowData, dataKey, ...props }) => {
    // console.log('rowData==>', rowData.projectName.name)
    let _color = '#ff9800'
    // if (schema.header === 'โครงการทั้งหมด') {
    //   _color = '#ff0000'
    // } else {
    //   _color = '#ff9800'
    // }

    return (
      <Cell {...props}>
        <Grid fluid>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              {rowData?.projectName?.name || ''}
            </Col>
            <Col lg={24} md={24} sm={24} xs={24} style={{ fontSize: 12, color: _color }}>
              {rowData?.projectName?.statusName && (
                <>
                  <Icon icon="exclamation-circle2" size="lg" />
                  &nbsp;&nbsp;
                  {rowData?.projectName?.statusName}
                </>
              )}
            </Col>
          </Row>
        </Grid>
      </Cell>
    )
  }

  return (
    <>
      {schema?.projectInfo && (
        <>
          <ProjectBasicInfo schema={schema.projectInfo} />
          <br />
        </>
      )}

      {isLoading && <OverlayLoader />}

      {/* <SubProjectMenuWidget mainProjectId={useProjectId} />

      <br /> */}

      <Panel
        header={schema?.subProjectList?.header}
        bordered
        collapsible={false}
        // shaded
        defaultExpanded
        className="table-all-project"
      >
        {searchRows?.enable && (
          <Grid fluid>
            <Row>
              <Col lg={5} md={12} sm={24} xs={24}>
                <ControlLabel>{schema.subProjectList.searchRows.projectCodeLabel}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={'projectcode'}
                  value={inputValueCode}
                  placeholder={`ระบุ${schema.subProjectList.searchRows.projectCodeLabel}`}
                  onChange={handleChangeProjectCode}
                ></Input>
              </Col>
              <Col lg={5} md={12} sm={24} xs={24}>
                <ControlLabel>{schema.subProjectList.searchRows.projectNameLabel}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={'projectname'}
                  value={inputValueName}
                  placeholder={`ระบุ${schema.subProjectList.searchRows.projectNameLabel}`}
                  onChange={handleChangeProjectName}
                ></Input>
              </Col>
              <Col lg={5} md={12} sm={24} xs={24}>
                <ControlLabel>
                  {schema.subProjectList.searchRows.projectStatusOption.label}
                </ControlLabel>
                <Controller
                  key={'projectyear'}
                  name={'projectyear'}
                  control={control}
                  render={(props) => {
                    return (
                      <SelectPicker
                        // key={}
                        style={{ width: '100%' }}
                        searchable={false}
                        defaultValue={''}
                        data={schema.subProjectList.searchRows.projectStatusOption.options}
                        onChange={(value) => {
                          setInputValueStatus(value)
                          console.log('value => ', value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col lg={9} md={12} sm={24} xs={24}>
                <div>
                  <br />
                  <SearchButton
                    style={{ minWidth: '20%', height: '35px' }}
                    children={schema.subProjectList.searchRows.buttonSearchText}
                    onClick={handleSearchProject}
                  />
                  &nbsp;
                  <CancelButton
                    style={{ minWidth: '20%', height: '35px' }}
                    children={schema.subProjectList.searchRows.buttonCancelText}
                    onClick={handleCancelSearchProject}
                  />
                  &nbsp;
                  <Button
                    size="sm"
                    color="yellow"
                    appearance="ghost"
                    style={{
                      height: '35px',
                      background: '#d6666696',
                      width: 'auto',
                      color: '#000000',
                    }}
                    onClick={() => {
                      onCancelSelectProject('cancel')
                    }}
                  >
                    <Icon icon="chevron-circle-up" style={{ paddingRight: '5px' }} />
                    {schema.subProjectList.searchRows.buttonSelectText}
                  </Button>
                </div>
              </Col>
            </Row>
            {/* </Form> */}
          </Grid>
        )}
        <div style={{ marginTop: '20px' }}>
          <Row gutter={16}>
            <Col lg={6} md={8} sm={24} xs={24}>
              {/* ปุ่มสร้างโครงการย่อย */}
              <ButtonToolbar>
                <Button
                  block
                  style={{ backgroundColor: '#2da888', color: '#ffffff' }}
                  size={'lg'}
                  onClick={() => {
                    handleGetTempalteSchema(schema?.projectInfo?.projectCode)
                  }}
                >
                  <Icon icon="plus-square" style={{ paddingRight: '5px' }} />
                  {schema.subProjectList.searchRows.buttonAddSubProjectText}
                </Button>
              </ButtonToolbar>
            </Col>
            <Col lg={6} md={8} sm={24} xs={24}>
              {/* ปุ่มบันทึกรายงานความก้าวหน้า */}
              {/* <ButtonToolbar>
                <Button
                  block
                  className="bt-magintop"
                  style={{ backgroundColor: '#2da888', color: '#ffffff' }}
                  size={'sm'}
                  // onClick={handleSaveProgressive}
                  onClick={() => {
                    sessionStorage.setItem('projectId', ProjectId)
                    sessionStorage.setItem('param', '')

                    history.push({
                      pathname: `${pathname.subProject.saveProgressive}`,
                    })
                  }}
                  // onClick={() => {
                  //   console.log('1234')
                  //   // onSaveProgressive()
                  // }}
                >
                  <Icon icon="save" style={{ paddingRight: '5px' }} />
                  {'บันทึกรายงานความก้าวหน้า'}
                </Button>
              </ButtonToolbar> */}
            </Col>
          </Row>
        </div>

        <Table
          wordWrap
          height={420}
          autoHeight={tableData.length < 5}
          // headerHeight={60}
          loading={loading}
          data={tableData}
          style={{ marginTop: '8px' }}
        >
          <Column align="center" width={170} fixed>
            <HeaderCell>
              <span>{schema.subProjectList.projectCodeText}</span>
            </HeaderCell>
            <Cell dataKey="code" />
          </Column>

          <Column width={430} minWidth={430} flexGrow={1}>
            <HeaderCell>
              <span>{schema.subProjectList.projectNameText}</span>
            </HeaderCell>
            <Cell dataKey="projectName" />
            {/* <SubnameCell dataKey="projectName" /> */}
          </Column>

          <Column width={130} align="center">
            <HeaderCell>
              <span>{schema.subProjectList.projectStartDateText}</span>
            </HeaderCell>
            <Cell dataKey="projectStartDate" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>
              <span>{schema.subProjectList.projectEndDateText}</span>
            </HeaderCell>
            <Cell dataKey="projectEndDate" />
          </Column>

          <Column width={130} align="center">
            <HeaderCell>
              <span>{schema.subProjectList.projectStatusText}</span>
            </HeaderCell>
            {/* <Cell dataKey="projectStatus" /> */}
            <Cell>
              {(rowData) => {
                if (rowData.isRowTotal) {
                  return (
                    <b style={{ color: '#2ba888', fontWeight: 'bold' }}>{rowData.projectStatus}</b>
                  )
                }
                return rowData.projectStatus
              }}
            </Cell>
          </Column>

          <Column width={220} align="right">
            <HeaderCell>
              <span>{schema.subProjectList.budgetSubProjectText}</span>
              {/* <HeaderSummary
                title={schema.subProjectList.budgetSubProjectText}
                summary={budgetFormat(schema.projectInfo.totalBudget) || 0}
              /> */}
            </HeaderCell>

            <Cell>
              {(rowData) => {
                if (rowData.isRowTotal) {
                  return (
                    <b style={{ color: '#2ba888', fontWeight: 'bold' }}>
                      {budgetFormat(rowData.projectBudget)}
                    </b>
                  )
                }
                return budgetFormat(rowData.projectBudget)
              }}
            </Cell>
          </Column>

          <Column width={150} align="center" fixed="right">
            <HeaderCell>
              <span></span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                if (rowData.isRowTotal) {
                  return ''
                }
                return (
                  <IconButton
                    appearance="ghost"
                    color="orange"
                    icon={
                      <Icon
                        icon={schema.subProjectList.single.singleIcon}
                        className="bt-gost-icon-radius-or"
                      />
                    }
                    onClick={() => {
                      sessionStorage.setItem('projectId', rowData.subProjectVersionId)
                      sessionStorage.setItem(SUB_PROJECT_ID, rowData.subProjectVersionId)
                      sessionStorage.setItem('param', '')

                      history.push({
                        pathname: `${pathname.subProject.overviewSubProject}`,
                      })
                    }}
                  >
                    {schema.subProjectList.single.buttonText}
                  </IconButton>
                )
              }}
            </Cell>
          </Column>
        </Table>

        {pagination && (
          <>
            <TablePagination
              lengthMenu={lengthMenu || defaultLengthMenu}
              activePage={page || defaultPage}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total} รายการ`}</>
              }}
              render
              displayLength={displayLength || 5}
              total={schema.subProjectList.totalSize}
              onChangePage={handleChangePage}
              onChangeLength={handleChangeLength}
            />
          </>
        )}

        {schema?.subProjectList.message && (
          <Row>
            <Message
              showIcon
              type={schema.subProjectList.message.type}
              description={schema.subProjectList.message.message}
            />
          </Row>
        )}

        <ConfirmWidget
          title={`ยืนยันการลบรายการ`}
          show={isShowConfirm}
          detail={`ยืนยันการลบ ${
            deleteObj?.projectName
              ? schema.subProjectList.projectNameText + ' : ' + deleteObj.projectName
              : ''
          }`}
          onCancle={() => {
            setIsShowConfirm(false)
            setDeleteObj({})
          }}
          onConfirm={() => {
            onRemove(deleteObj)
            let total = schema.subProjectList.values.length
            let newPage = Math.ceil(total / displayLength)
            if (newPage > 0 && newPage < page) {
              setPage(newPage)
            }
            setIsShowConfirm(false)
          }}
        />

        <ConfirmWidget
          title={'ยืนยันการเพิ่มโครงการย่อย'}
          show={isShowConfirmAddSubproject}
          detail={'ต้องการเพิ่มโครงการย่อยใหม่หรือไม่ ?'}
          onCancle={() => {
            setIsShowConfirmAddSubproject(false)
            setIsShowSelectTemple(true)
          }}
          onConfirm={handleCreateSubProject}
        />

        <Modal
          size="lg"
          overflow={true}
          show={isShowSelectTemple}
          onHide={() => {
            setIsShowSelectTemple(false)
          }}
        >
          <Modal.Header>
            <Modal.Title>{thempSchema?.title || ''}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {thempSchema?.templates?.map((item) => {
              return (
                <List hover style={{ marginBottom: 0 }}>
                  <List.Item key={'header'} index={999} style={{ backgroundColor: '#f2f1f1' }}>
                    <FlexboxGrid>
                      <FlexboxGrid.Item colspan={24}>
                        <label style={{ marginLeft: 10 }}>{item.header}</label>
                      </FlexboxGrid.Item>
                    </FlexboxGrid>
                  </List.Item>
                  {item.values?.map((e, index) => (
                    <List.Item key={e.id} index={index}>
                      <FlexboxGrid>
                        <FlexboxGrid.Item colspan={20} ver>
                          <label style={{ marginLeft: 30 }}>{e.name}</label>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item colspan={4} style={{ textAlign: 'right' }}>
                          <IconButton
                            appearance="ghost"
                            icon={<Icon icon="file-o" className="bt-gost-icon-radius" />}
                            onClick={() => {
                              setSubFormId(e.id)
                              setIsShowSelectTemple(false)
                              setIsShowConfirmAddSubproject(true)
                            }}
                            style={{ marginRight: 20 }}
                            // disabled={isLoading}
                          >
                            {'เลือก'}
                          </IconButton>
                        </FlexboxGrid.Item>
                      </FlexboxGrid>
                    </List.Item>
                  ))}
                </List>
              )
            })}
          </Modal.Body>
          {/* <Modal.Footer>
            <Button appearance="primary">Ok</Button>
            <Button appearance="subtle">Cancel</Button>
          </Modal.Footer> */}
        </Modal>
      </Panel>
    </>
  )
}
